import { render, staticRenderFns } from "./VariantTree.vue?vue&type=template&id=2064cb0f&scoped=true"
import script from "./VariantTree.vue?vue&type=script&lang=js"
export * from "./VariantTree.vue?vue&type=script&lang=js"
import style0 from "./VariantTree.vue?vue&type=style&index=0&id=2064cb0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064cb0f",
  null
  
)

export default component.exports